const benefitRoute = [
  {
    path: "/benefits",
    name: "benefits",
    component: () => import("@/views/benefits/Benefits"),
  },
  {
    path: "benefits/add",
    name: "benefitAdd",
    component: () => import("@/views/benefits/BenefitEdit"),
  },
  {
    path: "benefits/:id/edit",
    name: "benefitEdit",
    component: () => import("@/views/benefits/BenefitEdit"),
    props: (route) => {
      const id = Number.parseInt(route.params.id, 10);
      if (Number.isNaN(id)) {
        return 0;
      }
      return { id };
    },
  },
  {
    path: "benefits/:id",
    name: "benefit",
    component: () => import("@/views/benefits/Benefit"),
    props: (route) => {
      const id = Number.parseInt(route.params.id, 10);
      if (Number.isNaN(id)) {
        return 0;
      }
      return { id };
    },
  },
];

export default benefitRoute;
